export default __webpack_public_path__ + "static/media/enneperuhrsignet.9e457a12.png";